module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'writing') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    设置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.title),
      callback: function($$v) {
        _vm.$set(_vm.base, "title", $$v)
      },
      expression: "base.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "副标题"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.base.subtitle),
      callback: function($$v) {
        _vm.$set(_vm.base, "subtitle", $$v)
      },
      expression: "base.subtitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组件间距"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#27cc6a",
      "inactive-color": "#efefef"
    },
    model: {
      value: (_vm.base.padded),
      callback: function($$v) {
        _vm.$set(_vm.base, "padded", $$v)
      },
      expression: "base.padded"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "布局"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.config.align),
      callback: function($$v) {
        _vm.$set(_vm.config, "align", $$v)
      },
      expression: "config.align"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "left"
    }
  }, [_vm._v("居左")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "center"
    }
  }, [_vm._v("居中")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "right"
    }
  }, [_vm._v("居右")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文本内容"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 8,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.data[0].content),
      callback: function($$v) {
        _vm.$set(_vm.data[0], "content", $$v)
      },
      expression: "data[0].content"
    }
  })], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-756b90ed", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-756b90ed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/writing.vue
// module id = 2831
// module chunks = 0